import { MdOutlinePlaylistAdd } from "react-icons/md";
export const supplierCategoryMenu = [
  {
    id: "1",
    name: "سطح اول",
    path: `/dashboard/suppliers/ContentUnit/productCategory/level1-product-category`,
    icon: <MdOutlinePlaylistAdd size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "2",
    name: "سطح دوم",
    path: `/dashboard/suppliers/ContentUnit/productCategory/level2-product-category`,
    icon: <MdOutlinePlaylistAdd size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "3",
    name: "سطح سوم",
    path: `/dashboard/suppliers/ContentUnit/productCategory/level3-product-category`,
    icon: <MdOutlinePlaylistAdd size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "4",
    name: "افزودن برند",
    path: `/dashboard/suppliers/ContentUnit/productCategory/addBrand`,
    icon: <MdOutlinePlaylistAdd size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "5",
    name: "افزودن جدول کلمات",
    path: `/dashboard/suppliers/ContentUnit/productCategory/addTextTemplateTable`,
    icon: <MdOutlinePlaylistAdd size={25} />,
    color: "#0062FF",
    type: "menu",
  },
];
